import { MetaDataDto } from './../dto/MetadataDto';
import { BaseNodeConfig } from './../dto/NodeConfig';
import { environment } from './../environments/environment';
import { FlowResultDto } from './../dto/FlowResultDto';
import { ExpressionMethodDto } from 'dto/ExpressionMethodDto';
import { FlowConfig } from 'dto/FlowConfig';
import { UiElementType } from 'classes/UIElementType';
import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from "rxjs/Rx";
import { ReplaySubject } from "rxjs/ReplaySubject";
import { BaseDto } from "dto/BaseDto";

@Injectable()
export class ApiService {
    
    private apiRoot:string = environment.apiUrl;

    constructor(private http: Http) { 

    }

    getFlow(flowId:string):Observable<FlowConfig> {
        var headers = new Headers();
        headers.append('Cache-Control', 'no-cache');
        return this.http.get(this.apiRoot + '/flow/Get?flowid=' + flowId, { headers: headers }).map(
            response => {
                
                // custom mapping required to set the correct derived class type for the Nodes of this flow
                //var obj = response.json(); 
                //var flow = Object.assign(new FlowConfig(),obj);
                //flow.Nodes = [];
                
                //obj.Nodes.forEach(node=>flow.Nodes.push(Object.assign(new BaseNodeConfig(),node)));
                return response.json(); 
            }
        );
    }

    getExpressionMethods():Observable<ExpressionMethodDto[]> {
        return this.http.get(this.apiRoot + '/flow/GetExpressionMethods').map(response => response.json());
    }

    getFlowNames():Observable<BaseDto[]> {
        return this.http.get(this.apiRoot + '/flow').map(response => response.json());
    }

    saveFlowConfig(flowConfig:FlowConfig):Observable<string> {
        //flowConfig = <FlowDto>JSON.parse(`{"FlowId":"594a6af13f04596cda24a2ec","FlowType":0,"TriggeredBy":null,"Nodes":[{"Identifier":"ZqRmMYtinN","Name":"My first Node","TemplateId":null,"TriggeredBy":[],"Reevaluate":false,"NodeExpression":null,"UIElement":null},{"Identifier":"xjwCAmPxmO","Name":null,"TemplateId":null,"TriggeredBy":[{"Value":null,"Identifier":"ZqRmMYtinN","Name":"Always"}],"Reevaluate":false,"NodeExpression":null,"UIElement":null}],"Identifier":null,"Name":"Test 2017-06-21"}`)
        return this.http.post(this.apiRoot + '/flow/SaveFlowConfig',flowConfig).map(response =>  response.json());
    }

    processCycle(flowId:string, flowResultId:string, payload:any):Observable<FlowResultDto> {

        var headers = new Headers();
        headers.append('Cache-Control', 'no-cache');

        return this.http.post(this.apiRoot + '/flow/Process?flowid=' + flowId,
            {
                FlowResultId: flowResultId,
                Payload: payload
            }, 
            { 
                headers: headers 
            }).map(response =>  response.json());
    }

    private expressionTemplateCache:MetaDataDto[];
     /**
     * Returns a list of all the available templates for this tenant. Is fetched from the api using htpp if not called before else it is returned from the cache.
     */
    /**
     * Returns a list of all the available templates for this tenant. Is fetched from the api using http if not called before else it is returned from the cache.
     */
    public loadExpressionTemplates(forceRefresh?:boolean):Observable<MetaDataDto[]> {
        return Observable.create(observer => {
            if (!this.expressionTemplateCache || forceRefresh)
                this.http.get(this.apiRoot + '/expression/templates')
                    .map(response => response.json())
                    .subscribe(data => 
                    {
                        this.expressionTemplateCache = data;
                        observer.next(data);
                        observer.complete();
                    },
                    error => {
                        throw new Error('Failed to load templates.');
                    });
            else
            {
                observer.next(this.expressionTemplateCache);
                observer.complete();
            }
        });
    }

    /**
     * Returns a single template. Is fetched from the api using http if not called before else it is returned from the cache.
     */
     getExpressionTemplate(templateId:string):MetaDataDto {
         return this.expressionTemplateCache.find(template => template.Identifier == templateId);
     }

    private subflow
    /** Given a flowId, get a dictionary that for each SubFlow execution node in this flow lists all possible output values.
     * 
     * @param flowId The flow whose possible SubFlow node outputs should be gotten.
     */
     getSubflowOutputs(flowId:string):Observable<any> {
        return this.http.get(this.apiRoot + '/flow/SubFlowOutputs/' + flowId).map(response => response.json());
     }

     getResources():Observable<any[]> {
        return this.http.get(this.apiRoot + '/Resources').map(response => response.json());
    }
    
    saveResources(resources:any):Observable<any> {
        //flowConfig = <FlowDto>JSON.parse(`{"FlowId":"594a6af13f04596cda24a2ec","FlowType":0,"TriggeredBy":null,"Nodes":[{"Identifier":"ZqRmMYtinN","Name":"My first Node","TemplateId":null,"TriggeredBy":[],"Reevaluate":false,"NodeExpression":null,"UIElement":null},{"Identifier":"xjwCAmPxmO","Name":null,"TemplateId":null,"TriggeredBy":[{"Value":null,"Identifier":"ZqRmMYtinN","Name":"Always"}],"Reevaluate":false,"NodeExpression":null,"UIElement":null}],"Identifier":null,"Name":"Test 2017-06-21"}`)
        return this.http.post(this.apiRoot + '/Resources/'+resources.Scope+'/'+resources.Language,resources);
    }
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/services/api.service.ts